import * as m from "@/paraglide/messages";

const steps = [
  {
    tour: "dashboard",
    steps: [
      {
        icon: <>👋</>,
        title: m.this_house_jellyfish_enjoy(),
        content: <>{m.flaky_male_peacock_heart()}</>,
        selector: "#tour_exchangeselect",
        side: "right-top",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>🕒</>,
        title: m.cuddly_zany_piranha_wave(),
        content: <>{m.lofty_raw_anaconda_catch()}</>,
        selector: "#tour_sync",
        side: "left",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>📈</>,
        title: m.loved_mild_iguana_lock(),
        content: <>{m.less_fresh_kestrel_prosper()}</>,
        selector: "#tour_chartsettings",
        side: "left",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>🏦</>,
        title: m.petty_chunky_shrike_hope(),
        content: <>{m.petty_curly_trout_snap()}</>,
        selector: "#tour_exchangetable",
        side: "top",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>🔝</>,
        title: m.broad_equal_squirrel_hint(),
        content: <>{m.pretty_dry_canary_walk()}</>,
        selector: "#tour_topassets",
        side: "top",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>🔝</>,
        title: m.light_nimble_eagle_earn(),
        content: <>{m.east_dry_slug_mop()}</>,
        selector: "#tour_transactions",
        side: "top",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
    ],
  },
  {
    tour: "smart_allocation",
    steps: [
      {
        icon: <>👋</>,
        title: m.gray_plane_emu_drop(),
        content: m.loved_legal_turtle_animate(),
        selector: "#tour_baseasset",
        side: "right",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>⚙️</>,
        title: m.stout_bright_larva_bake(),
        content: m.busy_clean_rooster_loop(),
        selector: "#tour_saanalytics",
        side: "bottom",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>🍩</>,
        title: m.royal_these_puma_prosper(),
        content: m.zesty_best_bison_conquer(),
        selector: "#tour_weightchart",
        side: "right",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>📈</>,
        title: m.day_giant_cod_affirm(),
        content: m.raw_every_hamster_bend(),
        selector: "#tour_backtest",
        side: "left",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>➕</>,
        title: m.tough_front_samuel_greet(),
        content: m.maroon_orange_yak_flip(),
        selector: "#tour_addassets",
        side: "right",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>🔄</>,
        title: m.formal_sad_porpoise_clap(),
        content: m.sleek_wise_bobcat_drip(),
        selector: "#tour_save",
        side: "left",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
      {
        icon: <>📋</>,
        title: m.heavy_day_anteater_agree(),
        content: m.known_busy_pigeon_file(),
        selector: "#tour_satable",
        side: "top",
        showControls: true,
        pointerPadding: 0,
        pointerRadius: 4,
      },
    ],
  },
];

export default steps;
